import styled, { css } from 'styled-components'
import { StyledNavigationLink } from '../../UI/NavigationLink/styled'

export const StyledDropdownWrapper = styled.div`
  opacity: 0;
  padding-top: 1rem;
  pointer-events: none;
  position: fixed;
  transition: opacity 0.25s, visibility 0.25s;
  visibility: hidden;
  z-index: 101;
  max-width: calc(100vw - 1rem);
`

export const StyledDropdownBoxWrapper = styled.div`
  transform: translateY(0.25rem);
  transition: transform 0.25s;
  position: relative;
  z-index: 2;
`

export const StyledWrapper = styled.li<{ $inverted?: boolean }>`
  list-style: none;
  z-index: 1;

  &:hover {
    z-index: 3;

    ${StyledDropdownWrapper} {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
      transition-delay: 320ms;
    }

    ${StyledDropdownBoxWrapper} {
      transform: translateY(0);
    }
  }

  &:hover ${StyledNavigationLink}:not(.active):before {
    bottom: -2px;
    left: -2px;
    right: -2px;
    top: -2px;

    ${({ $inverted }) =>
      $inverted
        ? css`
                      background-color ${({ theme }) => theme.colors.black[1]};
                    `
        : css`
                      background-color ${({ theme }) => theme.colors.black[6]};
                    `}
  }
`
